module.exports = __webpack_public_path__ + "static/media/lx_adv_robot.4e39ff62.webp";